export type RuleSlot =
  | { id: string; kind: 'intro-list' }
  | { id: string; kind: 'prize-col'; gids: number[]; label: string }

export type ParsedRules = {
  markdown: string
  slots: RuleSlot[]
}

const IMPORT_LINE = /^import\s+.*?from\s+['"][^'"]+['"]\s*\n*/
const INTRO_LIST_TAG = /<IntroList\s*\/>/g
const PRIZE_COL_TAG =
  /<PrizeCol\s+gids=\{\[([^\]]*)\]\}\s+label="([^"]*)"\s*\/>/g

export function parseRules(source: string): ParsedRules {
  const stripped = source.replace(IMPORT_LINE, '').trimStart()
  const slots: RuleSlot[] = []
  let nextId = 0
  const makeId = () => `slot-${nextId++}`

  const withIntro = stripped.replace(INTRO_LIST_TAG, () => {
    const id = makeId()
    slots.push({ id, kind: 'intro-list' })
    return `<span data-slot="${id}"></span>`
  })

  const markdown = withIntro.replace(PRIZE_COL_TAG, (_, rawGids, label) => {
    const id = makeId()
    const gids = (rawGids as string)
      .split(',')
      .map((s) => Number(s.trim()))
      .filter((n) => Number.isFinite(n))
    slots.push({ id, kind: 'prize-col', gids, label })
    return `<span data-slot="${id}"></span>`
  })

  return { markdown, slots }
}
